import React, { FC } from "react";
import {
  ServiceCard,
  ServiceCardProps,
} from "../../components/cards/service-card";
import { Paragraph } from "../../components/typography/paragraph";
import { Spin } from "antd";
import { Container } from "../../components/container/container";
import { Carrocel } from "../../components/carousel/carrocel";
import { BreakPage } from "../../components/break-page/break-page";

export interface RelevantServicesProps {
  services?: ServiceCardProps[];
}

export const TopServices: FC<RelevantServicesProps> = ({ services }) => {
  return (
    <div className="xvia-relevant-services xvia-top-services">
      <Container className="xvia-relevant-services__container">
        <BreakPage text={"SERVIÇOS MAIS ACESSADOS"} color={"#02ADD5"} />
        <Carrocel aria-label="Carrossel de serviços mais acessados">
          {!!services &&
            services?.map((service) => {
              return (
                <div>
                  <ServiceCard
                    key={service.title}
                    title={service.title}
                    categoryIcon={service?.categoryIcon}
                    link={service.link}
                    onClickFavourite={service.onClickFavourite}
                    rating={service?.rating}
                    type={service?.type}
                    imageUrl={service?.imageUrl}
                    targets={service?.targets}
                  />
                </div>
              );
            })}
        </Carrocel>
        {!services && (
          <div className={"xvia-relevant-services__loading"}>
            <Spin />
          </div>
        )}
      </Container>
    </div>
  );
};
